import api from "../../../axiosConfig";

export const myContactsApi = {
  list: async ({ q = "", category = "", status = "", page = 1, perPage = 50 } = {}) => {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("per_page", String(perPage));
    if (q) params.set("q", q);
    if (category) params.set("category", category);
    if (status) params.set("status", status);
    const res = await api.get(`/my-contacts?${params.toString()}`);
    return res.data;
  },

  create: async (payload) => {
    const res = await api.post("/my-contacts", payload);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await api.put(`/my-contacts/${id}`, payload);
    return res.data;
  },

  remove: async (id) => {
    const res = await api.delete(`/my-contacts/${id}`);
    return res.data;
  },

  import: async (file) => {
    const form = new FormData();
    form.append("file", file);
    const res = await api.post("/my-contacts/import", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  stats: async () => {
    const res = await api.get("/my-contacts/stats");
    return res.data;
  },
};
